import CalendarSheet from "../../../../views/digibord/content/season/CalendarSheet.vue";
import createVideoPlayerRoute from "../create-video-player-route";

export default [
  {
    path: "kalender/:seasonSlug?/:daySlug?/",
    name: "CalendarSheet",
    component: CalendarSheet,
    meta: {
      containerClass: "showCalendarSheet",
    },
    children: [...createVideoPlayerRoute("CalendarSheetVideoPlayer")],
  },
];
